import React, {useState} from 'react';
import {Accordion, Card} from "react-bootstrap";
import './Section.css'

export const SectionBody = ({idea, example, actionableTip}) => <Card.Body>
  <h6>💡 Idea</h6>
  <p>{idea}</p>
  {example && <>
    <h6>Example</h6>
    <p>{example}</p>
  </>}
  <h6 className="mt-5">🎟️ Actionable Tip</h6>
  <p dangerouslySetInnerHTML={{__html: actionableTip}}/>
</Card.Body>;

const Section = ({header, list}) => {
  const [activeKey, setActiveKey] = useState('0');

  const onClick = (disabled) => {
    if (disabled) {
      document.getElementById("sign-up").scrollIntoView();
    }
  }

  return <div className="mb-5 text-left">
    <div className="col-10 col-lg-6 m-auto">
      <h3 className="mb-4">{header}</h3>
    </div>
    <div className="col-12 col-lg-6 m-auto">
      <Accordion defaultActiveKey="0" activeKey={activeKey} onSelect={e => setActiveKey(e)}>
        {list.map((i, key) =>
          <Card className={`item ${i.idea ? 'enabled' : 'disabled'}`} key={key}>
            <Accordion.Toggle className="toggle" as={Card.Header} eventKey={key} onClick={() => onClick(!i.idea)}>
              <h5 style={{flexGrow: 1}}>
                {i.header}
                {!i.idea && <span className="coming-soon">Coming Soon</span>}
              </h5>
              {i.idea && <div className="plus-icon">
                <img src={activeKey === key ? 'assets/minus.svg' : 'assets/plus.svg'} height="16px"/>
              </div>}
            </Accordion.Toggle>
            {i.idea && <Accordion.Collapse eventKey={key}>
              <SectionBody {...i} />
            </Accordion.Collapse>}
          </Card>)}
      </Accordion>
    </div>
  </div>
};

export default Section;
